module.exports={render:function (){var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;
  return _c('div', [_c('div', [(_vm.isLoading) ? _c('CustomLoader', {
    attrs: {
      "width": 70
    }
  }) : _vm._e()], 1), _vm._v(" "), _c('b-card', {
    staticClass: "mainCardBG"
  }, [_c('b-card-text', [_c('b-navbar', {
    staticClass: "formCard",
    staticStyle: {
      "border-radius": "5px !important",
      "padding-left": "0px"
    },
    attrs: {
      "toggleable": "lg",
      "type": "dark",
      "variant": "primary"
    }
  }, [_c('b-navbar-nav', [_c('b-button', {
    attrs: {
      "size": "sm",
      "variant": "light"
    },
    on: {
      "click": _vm.previousSalesView
    }
  }, [_c('md-icon', {
    attrs: {
      "icon": "gear-fill",
      "aria-hidden": "true"
    }
  }, [_vm._v("skip_previous")]), _vm._v("Back\n          ")], 1)], 1), _vm._v(" "), _c('b-navbar-brand', {
    attrs: {
      "center": ""
    }
  }, [_vm._v("Multi-Billing Assignment Details")])], 1), _vm._v(" "), _c('b-card', [_c('md-layout', {
    attrs: {
      "md-gutter": ""
    }
  }, [_c('md-layout', {
    attrs: {
      "md-flex": "25",
      "md-flex-small": "100"
    }
  }, [_c('date-range-picker', {
    attrs: {
      "opens": _vm.openRight,
      "always-show-calendars": _vm.showCal,
      "startDate": _vm.startDate,
      "endDate": _vm.endDate,
      "locale-data": _vm.locale
    },
    model: {
      value: (_vm.dateRange),
      callback: function($$v) {
        _vm.dateRange = $$v
      },
      expression: "dateRange"
    }
  })], 1), _vm._v(" "), _c('md-layout', {
    attrs: {
      "md-flex": "25",
      "md-flex-small": "100"
    }
  }, [_c('model-list-select', {
    staticClass: "ml-3",
    attrs: {
      "list": _vm.clientMaster,
      "id": "clientNamenew",
      "option-value": "clientId",
      "option-text": "clientName",
      "placeholder": "Select  Client Name"
    },
    model: {
      value: (_vm.clientIdFilter),
      callback: function($$v) {
        _vm.clientIdFilter = $$v
      },
      expression: "clientIdFilter"
    }
  })], 1), _vm._v(" "), _c('md-layout', {
    attrs: {
      "md-flex": "25",
      "md-flex-small": "100"
    }
  }, [_c('b-form-input', {
    staticClass: "ml-3",
    attrs: {
      "formatter": _vm.capitalizeAll,
      "placeholder": "Invoice Number"
    },
    model: {
      value: (_vm.InvoiceNoFilter),
      callback: function($$v) {
        _vm.InvoiceNoFilter = $$v
      },
      expression: "InvoiceNoFilter"
    }
  })], 1), _vm._v(" "), _c('md-layout', {
    attrs: {
      "md-flex": "25",
      "md-flex-small": "100"
    }
  }, [_c('b-form-input', {
    staticClass: "ml-3",
    attrs: {
      "formatter": _vm.capitalizeAll,
      "placeholder": " Shipping Bill No."
    },
    model: {
      value: (_vm.SBFilter),
      callback: function($$v) {
        _vm.SBFilter = $$v
      },
      expression: "SBFilter"
    }
  })], 1)], 1), _vm._v(" "), _c('md-layout', {
    staticClass: "mt-2",
    attrs: {
      "md-gutter": ""
    }
  }, [_c('md-layout', {
    attrs: {
      "md-flex": "25",
      "md-flex-small": "100"
    }
  }, [_c('b-form-input', {
    attrs: {
      "formatter": _vm.capitalizeAll,
      "placeholder": " Container  No."
    },
    model: {
      value: (_vm.ContainerFilter),
      callback: function($$v) {
        _vm.ContainerFilter = $$v
      },
      expression: "ContainerFilter"
    }
  })], 1), _vm._v(" "), _c('md-layout', {
    attrs: {
      "md-flex": "25",
      "md-flex-small": "100"
    }
  }, [_c('b-form-input', {
    staticClass: "ml-3",
    attrs: {
      "formatter": _vm.capitalizeAll,
      "placeholder": " Shipper Inv No."
    },
    model: {
      value: (_vm.shiperInvFilter),
      callback: function($$v) {
        _vm.shiperInvFilter = $$v
      },
      expression: "shiperInvFilter"
    }
  })], 1), _vm._v(" "), _c('md-layout', {
    attrs: {
      "md-flex": "25",
      "md-flex-small": "100"
    }
  }, [_c('b-form-input', {
    staticClass: "ml-3",
    attrs: {
      "formatter": _vm.capitalizeAll,
      "placeholder": " Assignment No."
    },
    model: {
      value: (_vm.assignmentFilter),
      callback: function($$v) {
        _vm.assignmentFilter = $$v
      },
      expression: "assignmentFilter"
    }
  })], 1), _vm._v(" "), _c('md-layout', {
    attrs: {
      "md-flex": "25",
      "md-flex-small": "100"
    }
  }, [_c('model-list-select', {
    staticClass: "ml-3",
    attrs: {
      "list": _vm.jobList,
      "option-value": "jv",
      "option-text": "jt",
      "placeholder": " JobType"
    },
    model: {
      value: (_vm.jobTypeFilter),
      callback: function($$v) {
        _vm.jobTypeFilter = $$v
      },
      expression: "jobTypeFilter"
    }
  })], 1)], 1), _vm._v(" "), _c('md-layout', {
    staticClass: "mt-2",
    attrs: {
      "md-gutter": ""
    }
  }, [_c('md-layout', {
    attrs: {
      "md-flex": "25",
      "md-flex-small": "100"
    }
  }, [_c('model-list-select', {
    attrs: {
      "list": _vm.branchList,
      "option-value": "pickupId",
      "option-text": "pickupLocation",
      "placeholder": " Branch"
    },
    model: {
      value: (_vm.branchfilter),
      callback: function($$v) {
        _vm.branchfilter = $$v
      },
      expression: "branchfilter"
    }
  })], 1), _vm._v(" "), _c('md-layout', {
    attrs: {
      "md-flex": "25",
      "md-flex-small": "100"
    }
  }, [_c('model-list-select', {
    staticClass: "ml-3",
    attrs: {
      "list": _vm.invoiceStatusList,
      "option-value": "inv",
      "option-text": "int",
      "placeholder": "Select Status"
    },
    model: {
      value: (_vm.statusFilter),
      callback: function($$v) {
        _vm.statusFilter = $$v
      },
      expression: "statusFilter"
    }
  })], 1), _vm._v(" "), _c('md-layout', {
    attrs: {
      "md-flex": "25",
      "md-flex-small": "100"
    }
  }, [_c('model-list-select', {
    staticClass: "ml-3",
    attrs: {
      "list": _vm.SOBStatusList,
      "option-value": "inv",
      "option-text": "int",
      "placeholder": "Select SOB Status"
    },
    model: {
      value: (_vm.SOBFilter),
      callback: function($$v) {
        _vm.SOBFilter = $$v
      },
      expression: "SOBFilter"
    }
  })], 1), _vm._v(" "), _c('md-layout', {
    attrs: {
      "md-flex": "25",
      "md-flex-small": "100"
    }
  }, [_c('model-list-select', {
    staticClass: "ml-3",
    attrs: {
      "list": _vm.BillingStatusList,
      "option-value": "inv",
      "option-text": "int",
      "placeholder": "Select Billing Status"
    },
    model: {
      value: (_vm.BillingFilter),
      callback: function($$v) {
        _vm.BillingFilter = $$v
      },
      expression: "BillingFilter"
    }
  })], 1), _vm._v(" "), _c('md-layout', {
    attrs: {
      "md-flex": "100"
    }
  }, [_c('b-form-group', {
    staticClass: "mt-3"
  }, [_c('b-form-checkbox-group', {
    attrs: {
      "id": "checkbox-group-1",
      "options": _vm.jobRecList,
      "name": "flavour-1"
    },
    model: {
      value: (_vm.jobRecFilter),
      callback: function($$v) {
        _vm.jobRecFilter = $$v
      },
      expression: "jobRecFilter"
    }
  })], 1)], 1)], 1), _vm._v(" "), _c('md-layout', {
    staticClass: "justify-content-center mt-3",
    attrs: {
      "md-gutter": ""
    }
  }, [_c('b-button', {
    attrs: {
      "size": "sm",
      "variant": "outline-primary"
    },
    on: {
      "click": _vm.filterSearch
    }
  }, [_vm._v("Search")]), _vm._v(" "), _c('b-button', {
    staticClass: "ml-3",
    attrs: {
      "size": "sm",
      "variant": "outline-info"
    },
    on: {
      "click": _vm.clearFilter
    }
  }, [_vm._v("clear")]), _vm._v(" "), _c('b-button', {
    staticClass: "ml-3",
    attrs: {
      "size": "sm",
      "variant": "outline-info"
    },
    on: {
      "click": function($event) {
        _vm.getReports('BILLING_SCREEN')
      }
    }
  }, [_vm._v("Export as Excel")]), _vm._v(" "), _c('b-button', {
    staticClass: "ml-3",
    attrs: {
      "size": "sm",
      "variant": "outline-info"
    },
    on: {
      "click": function($event) {
        _vm.getReports('BILLING_SCREEN_ALL')
      }
    }
  }, [_vm._v("Export All Execution ")]), _vm._v(" "), _c('b-button', {
    staticClass: "ml-3",
    attrs: {
      "size": "sm",
      "variant": "outline-info"
    },
    on: {
      "click": function($event) {
        _vm.getReports('MultiBILLING_SCREEN')
      }
    }
  }, [_vm._v("Export All Multi Bill")])], 1), _vm._v(" "), _c('div', {
    staticClass: "gutr"
  })], 1), _vm._v(" "), _c('div', {
    staticClass: "box"
  }, [_c('div', [_c('b-pagination', {
    staticClass: "mt-3",
    staticStyle: {
      "margin": "0px"
    },
    attrs: {
      "limit": "25",
      "align": "center",
      "per-page": _vm.perPage,
      "total-rows": _vm.totalRows
    },
    on: {
      "change": function($event) {
        _vm.onPageChange($event)
      }
    },
    model: {
      value: (_vm.currentPage),
      callback: function($$v) {
        _vm.currentPage = $$v
      },
      expression: "currentPage"
    }
  })], 1), _vm._v(" "), _c('div', [_c('b-row', {
    staticClass: "align-content-end mt-3"
  }, [_c('b-col', {
    attrs: {
      "cols": "8"
    }
  }, [_c('input', {
    directives: [{
      name: "model",
      rawName: "v-model",
      value: (_vm.isCheckAll),
      expression: "isCheckAll"
    }],
    attrs: {
      "type": "checkbox"
    },
    domProps: {
      "checked": Array.isArray(_vm.isCheckAll) ? _vm._i(_vm.isCheckAll, null) > -1 : (_vm.isCheckAll)
    },
    on: {
      "click": function($event) {
        _vm.SelectAll(_vm.consoBooking)
      },
      "change": function($event) {
        var $$a = _vm.isCheckAll,
          $$el = $event.target,
          $$c = $$el.checked ? (true) : (false);
        if (Array.isArray($$a)) {
          var $$v = null,
            $$i = _vm._i($$a, $$v);
          if ($$el.checked) {
            $$i < 0 && (_vm.isCheckAll = $$a.concat([$$v]))
          } else {
            $$i > -1 && (_vm.isCheckAll = $$a.slice(0, $$i).concat($$a.slice($$i + 1)))
          }
        } else {
          _vm.isCheckAll = $$c
        }
      }
    }
  }), _vm._v(" "), _c('label', [_vm._v("Select / Deselect All Count(" + _vm._s(this.AllModule_ids.length) + ")")]), _vm._v(" "), _c('b-button', {
    staticClass: "ml-2",
    attrs: {
      "size": "sm",
      "text": "View Mult-Billing",
      "variant": "outline-info"
    },
    on: {
      "click": function($event) {
        _vm.openMultiBillingAssDetails()
      }
    }
  }, [_vm._v("Mult-Billing")]), _vm._v(" "), (_vm.AllModule_ids.length > 0) ? _c('b-button', {
    staticClass: "m-2",
    attrs: {
      "size": "sm",
      "text": "Revised Billing Request",
      "variant": "outline-primary"
    },
    on: {
      "click": function($event) {
        _vm.openPop('multiple', _vm.arr = [])
      }
    }
  }, [_vm._v("Revised Billing Request")]) : _vm._e(), _c('br')], 1), _vm._v(" "), _c('b-col', {
    attrs: {
      "cols": "2"
    }
  }, [_c('h5', {
    staticClass: "text-muted pull-right"
  }, [(_vm.isLoading == false) ? _c('small', [_vm._v(_vm._s(_vm.totalRows) + " Entries")]) : _vm._e()])]), _vm._v(" "), _c('b-col', {
    staticStyle: {
      "padding": "0px 1rem 0 5rem"
    },
    attrs: {
      "cols": "2"
    }
  }, [_c('model-list-select', {
    attrs: {
      "list": _vm.PaginationList,
      "option-value": "pagv",
      "option-text": "pagt",
      "placeholder": "Select"
    },
    on: {
      "input": function($event) {
        _vm.pagechangeData()
      }
    },
    model: {
      value: (_vm.PaginationCount),
      callback: function($$v) {
        _vm.PaginationCount = $$v
      },
      expression: "PaginationCount"
    }
  })], 1)], 1)], 1), _vm._v(" "), _c('div', {
    staticClass: "table-responsive tableMain mt-2"
  }, [_c('b-table', {
    attrs: {
      "show-empty": "",
      "stacked": "md",
      "items": _vm.consoBooking,
      "fields": _vm.fields,
      "per-page": _vm.perPage,
      "sort-by": _vm.sortBy,
      "sort-desc": _vm.sortDesc,
      "sort-direction": _vm.sortDirection
    },
    on: {
      "update:sortBy": function($event) {
        _vm.sortBy = $event
      },
      "update:sortDesc": function($event) {
        _vm.sortDesc = $event
      }
    },
    scopedSlots: _vm._u([{
      key: "jobType",
      fn: function(row0) {
        return [(row0.item.revisedActionTakenFromMail != 1) ? _c('input', {
          directives: [{
            name: "model",
            rawName: "v-model",
            value: (_vm.AllModule_ids),
            expression: "AllModule_ids"
          }],
          attrs: {
            "type": "checkbox",
            "id": row0.item.TPTClient
          },
          domProps: {
            "value": row0.item.allModuleId,
            "checked": Array.isArray(_vm.AllModule_ids) ? _vm._i(_vm.AllModule_ids, row0.item.allModuleId) > -1 : (_vm.AllModule_ids)
          },
          on: {
            "change": [function($event) {
              var $$a = _vm.AllModule_ids,
                $$el = $event.target,
                $$c = $$el.checked ? (true) : (false);
              if (Array.isArray($$a)) {
                var $$v = row0.item.allModuleId,
                  $$i = _vm._i($$a, $$v);
                if ($$el.checked) {
                  $$i < 0 && (_vm.AllModule_ids = $$a.concat([$$v]))
                } else {
                  $$i > -1 && (_vm.AllModule_ids = $$a.slice(0, $$i).concat($$a.slice($$i + 1)))
                }
              } else {
                _vm.AllModule_ids = $$c
              }
            }, function($event) {
              _vm.updateSelectAll($event, row0.item)
            }]
          }
        }) : _vm._e(), _vm._v(" "), _c('span', [_vm._v(_vm._s(row0.index + 1 + (_vm.currentPage - 1) * _vm.perPage))])]
      }
    }, {
      key: "mainSalesSeries",
      fn: function(row1) {
        return [_c('md-icon', [_vm._v(_vm._s(row1.item.shipmentType == "1" || row1.item.shipmentType == "Sea_Shipment" ?
          "directions_boat" :
          "flight_takeoff"))]), _vm._v(" "), _c('b', [_vm._v(_vm._s(row1.item.mainSalesSeries))]), _vm._v(" "), _c('br'), _vm._v(" "), _c('span', [_vm._v("\n                " + _vm._s(row1.item.jobType) + " (" + _vm._s(row1.item.shipmentType == "1" || row1.item.shipmentType == "Sea_Shipment" ? "Sea" : "Air") + "\n                " + _vm._s(row1.item.transportType) + ")")]), _vm._v(" "), _c('br'), _vm._v(" "), _c('span', [_vm._v("Assignment Dt. :\n                " + _vm._s(_vm._f("moment")(row1.item.assignmentDate)))]), _vm._v(" "), _c('br'), _vm._v(" "), _c('span', [_vm._v("Raised From : " + _vm._s(row1.item.raisedFrom)), _c('br')]), _vm._v(" "), _c('span', [_vm._v(" By : " + _vm._s(row1.item.raisedBy))]), _vm._v(" "), _c('br'), _vm._v(" "), (row1.item.sob_date_detected != '' && row1.item.sob_date_detected != null) ? _c('span', [_c('b', {
          style: ('color:black')
        }, [_vm._v("SOB : " + _vm._s(row1.item.sob_date_detected))]), _vm._v(" "), _c('b-badge', {
          attrs: {
            "variant": "danger"
          }
        }, [_c('b', [_vm._v("SAILED")])])], 1) : _vm._e(), _vm._v(" "), _c('br'), _vm._v(" "), _c('b-button', {
          staticClass: "mt-2",
          staticStyle: {
            "font-size": "0.675rem"
          },
          attrs: {
            "size": "sm",
            "variant": "outline-info"
          },
          on: {
            "click": function($event) {
              _vm.showDocModal(row1.item)
            }
          }
        }, [_vm._v("Summary & Documents")]), _vm._v(" "), _c('br'), _vm._v(" "), (row1.item.splitFromId != '0') ? _c('h7', {
          staticClass: "mt-2"
        }, [_c('b-badge', {
          attrs: {
            "variant": "info"
          }
        }, [_vm._v("Split of " + _vm._s(row1.item.splitFromNo))])], 1) : _vm._e()]
      }
    }, {
      key: "TPTClient",
      fn: function(row11) {
        return [(
          row11.item.clientType == '3' &&
          row11.item.transportType == 'Export'
        ) ? _c('b', [_vm._v("\n                Client Name : " + _vm._s(row11.item.exporter) + "\n                "), _c('br')]) : _vm._e(), _vm._v(" "), (row11.item.clientType == '3') ? _c('b', [_vm._v("\n                Overseas Agent : " + _vm._s(row11.item.TPTClient) + "\n                "), _c('br')]) : _vm._e(), _vm._v(" "), (row11.item.clientType != '3') ? _c('b', [_vm._v("\n                " + _vm._s(row11.item.TPTClient) + "\n                "), _c('br')]) : _vm._e()]
      }
    }, {
      key: "ffInvoiceClosed",
      fn: function(row2) {
        return [(row2.item.jobType.split(',').includes('FF')) ? _c('span', [_vm._v("\n                FF :-\n                " + _vm._s(row2.item.ffInvoiceClosed == "1" ?
          "Received" :
          "Not-Received")), _c('br')]) : _vm._e(), _vm._v(" "), (row2.item.jobType.split(',').includes('CC')) ? _c('span', [_vm._v("\n                CC :-\n                " + _vm._s(row2.item.ccInvoiceClosed == "1" ?
          "Received" :
          "Not-Received")), _c('br')]) : _vm._e(), _vm._v(" "), (row2.item.jobType.split(',').includes('TPT')) ? _c('span', [_vm._v("TPT :-\n                " + _vm._s(row2.item.tptInvoiceClosed == "1" ?
          "Received" :
          "Not-Received"))]) : _vm._e()]
      }
    }, {
      key: "containerNo",
      fn: function(row15) {
        return [(row15.item.containerNo) ? _c('div', _vm._l((row15.item.containerNo.split(',')), function(item1, index) {
          return _c('span', {
            key: index
          }, [_c('h6', [_c('b-badge', {
            attrs: {
              "variant": "light"
            }
          }, [_vm._v(_vm._s(item1 == "" ? "-------" : item1) + "\n                    ")])], 1)])
        })) : _c('span', [_vm._v("-----------")])]
      }
    }, {
      key: "shipperInv",
      fn: function(row150) {
        return [(row150.item.shipperInv) ? _c('div', _vm._l((row150.item.shipperInv.split(',')), function(item2, index) {
          return _c('span', {
            key: index
          }, [_c('h6', [_c('b-badge', {
            attrs: {
              "variant": "light"
            }
          }, [_vm._v(_vm._s(item2 == "" ? "-------" : item2) + "\n                    ")])], 1)])
        })) : _c('span', [_vm._v("-----------")])]
      }
    }, {
      key: "ShippingB",
      fn: function(row100) {
        return [(row100.item.ShippingB) ? _c('div', _vm._l((row100.item.ShippingB.split(',')), function(item3, index) {
          return _c('span', {
            key: index
          }, [_c('h6', [_c('b-badge', {
            attrs: {
              "variant": "light"
            }
          }, [_vm._v(_vm._s(item3 == "" ? "-------" : item3) + "\n                    ")])], 1)])
        })) : _c('span', [_vm._v("-----------")])]
      }
    }, {
      key: "billingSeries",
      fn: function(row1000) {
        return [(row1000.item.invoiceNoCreated) ? _c('div', _vm._l((row1000.item.invoiceNoCreated.split(',')), function(item3, index) {
          return _c('span', {
            key: index
          }, [_c('h6', [_c('b-badge', {
            attrs: {
              "variant": "light"
            }
          }, [_vm._v(_vm._s(item3 == "" ? "-------" : item3) + "\n                    ")])], 1)])
        })) : _c('span', [_vm._v("-----------")])]
      }
    }, {
      key: "mainEnquiryId",
      fn: function(row15) {
        return [_c('b-button', {
          attrs: {
            "variant": "primary",
            "size": "sm"
          },
          on: {
            "click": function($event) {
              _vm.proceedBilling(
                row15.item.allModuleId,
                row15.item.newContainerFlow,
                row15.item.isConsolidation,
                row15.item.mainSalesSeries
              )
            }
          }
        }, [_vm._v(_vm._s(row15.item.finalBillingCompleted == "1" ?
          "Show Billing" :
          "Proceed To Billing"))]), _c('br'), _c('br'), _vm._v(" "), (row15.item.frghtTermsMbl == 'Collect' && row15.item.frghtTermsHbl == 'Collect') ? _c('b-badge', {
          staticClass: "p-2",
          attrs: {
            "variant": "warning"
          }
        }, [_c('b', [_vm._v("Credit Note Pending")]), _c('br')]) : _vm._e(), _vm._v(" "), (row15.item.uploadCreditDebit != '' && row15.item.approvalStatus == '1') ? _c('b-badge', {
          staticClass: "p-2",
          attrs: {
            "variant": "warning",
            "size": "sm"
          },
          on: {
            "click": function($event) {
              _vm.PrintNote(row15.item.mainSalesSeries, row15.item.uploadCreditDebit)
            }
          }
        }, [(row15.item.creditDebitNoteType == '1') ? _c('span', [_vm._v("Credit Note ")]) : _c('span', [_vm._v("Debit Note ")]), _vm._v("PDF"), _c('br')]) : _vm._e(), _vm._v(" "), (row15.item.isConsolidation == '1') ? _c('b-badge', {
          attrs: {
            "variant": "warning"
          }
        }, [_vm._v("Consolidation")]) : _vm._e(), _vm._v(" "), ((row15.item.finalBillingCompleted == '1')) ? _c('b-badge', {
          attrs: {
            "variant": "success"
          }
        }, [_vm._v("Billing Completed")]) : (row15.item.finalBillingCompleted == '4') ? _c('b-badge', {
          attrs: {
            "variant": "success"
          }
        }, [_vm._v("Billing Completed - Agent Expense Pending")]) : _c('b-badge', {
          attrs: {
            "variant": "danger"
          }
        }, [_vm._v("Billing In-complete")]), _vm._v(" "), _c('br'), _vm._v(" "), (row15.item.finalBillingCompleted != '1') ? _c('b-button', {
          staticClass: "mt-2",
          staticStyle: {
            "font-size": "0.675rem"
          },
          attrs: {
            "size": "sm",
            "variant": "outline-info"
          },
          on: {
            "click": function($event) {
              _vm.validateBilling(row15.item.allModuleId, row15.item.jobType)
            }
          }
        }, [_vm._v("Close Billing")]) : _vm._e(), _vm._v(" "), (row15.item.finalBillingCompleted == '1') ? _c('b-button', {
          staticClass: "m-2",
          staticStyle: {
            "font-size": "0.675rem"
          },
          attrs: {
            "disabled": row15.item.sentForRevisedApproval == '1' ? true : false,
            "size": "sm",
            "text": "View Mult-Billing",
            "variant": "outline-info"
          },
          on: {
            "click": function($event) {
              _vm.openPop('single', row15.item)
            }
          }
        }, [_vm._v("Revised Billing Request")]) : _vm._e(), _c('br'), _vm._v(" "), (row15.item.assignmentCloseReason) ? _c('span', {
          staticStyle: {
            "color": "green"
          },
          domProps: {
            "innerHTML": _vm._s(row15.item.assignmentCloseReason)
          }
        }, [_vm._v(_vm._s(_vm.wordWrap(row15.item.assignmentCloseReason, 12)))]) : _vm._e(), _c('br'), _vm._v(" "), (row15.item.revisedActionTakenFromMail == '2') ? _c('span', {
          staticClass: "error"
        }, [_vm._v("Request Rejected")]) : _vm._e()]
      }
    }])
  })], 1)]), _vm._v(" "), _c('div', [_c('b-pagination', {
    attrs: {
      "limit": "25",
      "align": "center",
      "per-page": _vm.perPage,
      "total-rows": _vm.totalRows
    },
    on: {
      "change": function($event) {
        _vm.onPageChange($event)
      }
    },
    model: {
      value: (_vm.currentPage),
      callback: function($$v) {
        _vm.currentPage = $$v
      },
      expression: "currentPage"
    }
  })], 1)], 1)], 1), _vm._v(" "), _c('div', [_c('b-modal', {
    ref: "doc-modal",
    staticClass: "modal-dialog-doc",
    attrs: {
      "size": "xl",
      "no-close-on-esc": "",
      "no-close-on-backdrop": "",
      "hide-footer": "",
      "title": ""
    }
  }, [(_vm.ALLMODULE) ? _c('div', [_c('doc-form', {
    attrs: {
      "allModuleIdProp": _vm.ALLMODULE,
      "JOBSERIES": _vm.JOBSERIES
    }
  })], 1) : _vm._e(), _vm._v(" "), _c('b-button', {
    staticClass: "mt-3",
    attrs: {
      "variant": "outline-danger",
      "block": ""
    },
    on: {
      "click": _vm.hideDocModal
    }
  }, [_vm._v("Close\n      ")])], 1)], 1), _vm._v(" "), _c('b-modal', {
    ref: "modal-close-conf",
    attrs: {
      "id": "modal-close-conf",
      "title": "Submit Your Reason",
      "centered": "",
      "no-close-on-esc": "",
      "no-close-on-backdrop": "",
      "hide-footer": ""
    }
  }, [_c('h3', [_vm._v("Confirmation")]), _vm._v(" "), (_vm.incompleteJobBill) ? _c('h4', {
    staticClass: "error"
  }, [_c('small', [_vm._v("Invoice Not added for ")]), _vm._v(" " + _vm._s(_vm.incompleteJobBill) + "  "), _c('small', [_vm._v(" Please Kindly Check..!")])]) : _vm._e(), _vm._v(" "), _c('form', {
    ref: "form"
  }, [_c('b-form-group', {
    attrs: {
      "label": "Reason for closing assignment billing",
      "label-for": "name-input",
      "invalid-feedback": "Name is required"
    }
  }, [_c('b-form-textarea', {
    attrs: {
      "formatter": _vm.capitalizeAll,
      "rows": "5",
      "id": "name-input",
      "required": ""
    },
    model: {
      value: (_vm.closingReason),
      callback: function($$v) {
        _vm.closingReason = $$v
      },
      expression: "closingReason"
    }
  })], 1)], 1), _vm._v(" "), _c('b-button', {
    attrs: {
      "disabled": _vm.closingReason ? false : true,
      "variant": "success"
    },
    on: {
      "click": _vm.closeBillOk
    }
  }, [_vm._v(" Confirm & Close Billing")]), _vm._v(" "), _c('b-button', {
    staticClass: "pull-right",
    attrs: {
      "variant": "danger"
    },
    on: {
      "click": _vm.closeModalConfirm
    }
  }, [_vm._v(" Cancel")])], 1), _vm._v(" "), _c('md-dialog-confirm', {
    ref: "addPopMail",
    attrs: {
      "md-content-html": _vm.alert.content,
      "md-ok-text": _vm.alert.ok
    },
    on: {
      "close": _vm.onCloseAction
    }
  }), _vm._v(" "), _c('md-dialog-confirm', {
    ref: "popMail",
    attrs: {
      "md-title": _vm.confirm.title,
      "md-content-html": _vm.confirm.contentHtml,
      "md-ok-text": _vm.confirm.ok,
      "md-cancel-text": _vm.confirm.cancel
    },
    on: {
      "close": _vm.sendMail
    }
  }), _vm._v(" "), _c('md-dialog-confirm', {
    ref: "addPopApprove",
    attrs: {
      "md-content-html": _vm.alert.content,
      "md-ok-text": _vm.alert.ok
    },
    on: {
      "close": _vm.onCloseAction
    }
  }), _vm._v(" "), _c('md-dialog-confirm', {
    ref: "addPopReject",
    attrs: {
      "md-content-html": _vm.alert.content,
      "md-ok-text": _vm.alert.ok
    },
    on: {
      "close": _vm.onCloseAction
    }
  }), _vm._v(" "), _c('md-dialog-confirm', {
    ref: "addPopDelete",
    attrs: {
      "md-content-html": _vm.alert.content,
      "md-ok-text": _vm.alert.ok
    },
    on: {
      "close": _vm.onCloseAction
    }
  }), _vm._v(" "), _c('md-dialog-confirm', {
    ref: "addPopTally",
    attrs: {
      "md-content-html": _vm.alert.content,
      "md-ok-text": _vm.alert.ok
    },
    on: {
      "close": _vm.closeBillOk
    }
  }), _vm._v(" "), _c('md-dialog-confirm', {
    ref: "addPopClose1",
    attrs: {
      "md-content-html": _vm.alert.content,
      "md-ok-text": _vm.alert.ok
    },
    on: {
      "close": _vm.closeBillOk
    }
  }), _vm._v(" "), _c('md-dialog-confirm', {
    ref: "addPopClose",
    attrs: {
      "md-content-html": _vm.alert.content,
      "md-ok-text": _vm.alert.ok
    },
    on: {
      "close": _vm.closeconsolidationTXTOk
    }
  }), _vm._v(" "), _c('md-dialog-alert', {
    ref: "addPop",
    attrs: {
      "md-content": _vm.alert.content,
      "md-ok-text": _vm.alert.ok
    }
  }), _vm._v(" "), _c('b-modal', {
    ref: "MultiBill-modal",
    attrs: {
      "no-close-on-esc": "",
      "no-close-on-backdrop": "",
      "size": "xl",
      "hide-footer": "",
      "title": 'Multi Billing Assignment'
    }
  }, [_c('div', {
    staticClass: "d-block text-center"
  }, [_c('h4', {
    staticClass: "error "
  }, [_vm._v(_vm._s('Sent Multi Billing'))])]), _vm._v(" "), _c('b-row', [_c('b-col', {
    attrs: {
      "cols": "12"
    }
  }, [_c('table', {
    staticClass: "table table-sm table-bordered mt-2"
  }, [_c('tbody', {
    staticStyle: {
      "background": "white"
    }
  }, [(_vm.MultibillingAss.length > 0) ? _c('tr', [_c('th', {
    staticStyle: {
      "width": "200px"
    },
    attrs: {
      "scope": "col"
    }
  }, [_vm._v("SN.\n              "), _c('input', {
    directives: [{
      name: "model",
      rawName: "v-model",
      value: (_vm.isCheckAllMulti),
      expression: "isCheckAllMulti"
    }],
    attrs: {
      "type": "checkbox"
    },
    domProps: {
      "checked": Array.isArray(_vm.isCheckAllMulti) ? _vm._i(_vm.isCheckAllMulti, null) > -1 : (_vm.isCheckAllMulti)
    },
    on: {
      "click": function($event) {
        _vm.SelectAllMulti(_vm.MultibillingAss)
      },
      "change": function($event) {
        var $$a = _vm.isCheckAllMulti,
          $$el = $event.target,
          $$c = $$el.checked ? (true) : (false);
        if (Array.isArray($$a)) {
          var $$v = null,
            $$i = _vm._i($$a, $$v);
          if ($$el.checked) {
            $$i < 0 && (_vm.isCheckAllMulti = $$a.concat([$$v]))
          } else {
            $$i > -1 && (_vm.isCheckAllMulti = $$a.slice(0, $$i).concat($$a.slice($$i + 1)))
          }
        } else {
          _vm.isCheckAllMulti = $$c
        }
      }
    }
  }), _vm._v(" "), _c('label', [_vm._v("Select / Deselect All Count(" + _vm._s(this.AllModule_ids.length) + ")")])]), _vm._v(" "), _c('th', {
    staticStyle: {
      "width": "600px"
    },
    attrs: {
      "scope": "col"
    }
  }, [_vm._v("Assignment Details")])]) : _vm._e(), _vm._v(" "), _vm._l((_vm.MultibillingAss), function(item, index) {
    return _c('tr', {
      key: index
    }, [_c('td', {
      attrs: {
        "scope": "row"
      }
    }, [_vm._v(_vm._s(index + 1) + ".\n              "), (item.revisedActionTakenFromMail == 1) ? _c('input', {
      directives: [{
        name: "model",
        rawName: "v-model",
        value: (_vm.AllModule_ids),
        expression: "AllModule_ids"
      }],
      attrs: {
        "type": "checkbox",
        "id": item.TPTClient
      },
      domProps: {
        "value": item.allModuleId,
        "checked": Array.isArray(_vm.AllModule_ids) ? _vm._i(_vm.AllModule_ids, item.allModuleId) > -1 : (_vm.AllModule_ids)
      },
      on: {
        "change": [function($event) {
          var $$a = _vm.AllModule_ids,
            $$el = $event.target,
            $$c = $$el.checked ? (true) : (false);
          if (Array.isArray($$a)) {
            var $$v = item.allModuleId,
              $$i = _vm._i($$a, $$v);
            if ($$el.checked) {
              $$i < 0 && (_vm.AllModule_ids = $$a.concat([$$v]))
            } else {
              $$i > -1 && (_vm.AllModule_ids = $$a.slice(0, $$i).concat($$a.slice($$i + 1)))
            }
          } else {
            _vm.AllModule_ids = $$c
          }
        }, function($event) {
          _vm.updateSelectAllMulti($event, item)
        }]
      }
    }) : _vm._e()]), _vm._v(" "), _c('td', [_vm._v(_vm._s(item.mainSalesSeries) + "\n              ")])])
  })], 2)])])], 1), _vm._v(" "), _c('b-row', {
    staticClass: "justify-content-center"
  }, [_c('b-col', {
    staticClass: "text-center",
    attrs: {
      "cols": "12"
    }
  }, [(_vm.AllModule_ids.length > 0) ? _c('b-button', {
    staticClass: "mt-3",
    attrs: {
      "size": "sm",
      "variant": "outline-primary"
    },
    on: {
      "click": _vm.ProceedMultiBilling
    }
  }, [_vm._v("Proceed Multi Billing")]) : _vm._e(), _vm._v(" "), _c('b-button', {
    staticClass: "mt-3",
    attrs: {
      "variant": "outline-danger"
    },
    on: {
      "click": _vm.hideMultiBillModal
    }
  }, [_vm._v("Close")])], 1)], 1)], 1), _vm._v(" "), _c('b-modal', {
    ref: "modal-multibill-confirm",
    attrs: {
      "id": "modal-multibill-confirm",
      "title": "Submit Your Reason",
      "centered": "",
      "no-close-on-esc": "",
      "no-close-on-backdrop": "",
      "hide-footer": ""
    }
  }, [_c('h3', [_vm._v("Confirmation")]), _vm._v(" "), (_vm.message != '') ? _c('h4', {
    staticClass: "error"
  }, [_c('small', [_vm._v(_vm._s(_vm.message))])]) : _vm._e(), _vm._v(" "), _c('b-button', {
    attrs: {
      "variant": "success"
    },
    on: {
      "click": function($event) {
        _vm.closeconsolidationTXTOk('Ok')
      }
    }
  }, [_vm._v(" Proceed")]), _vm._v(" "), _c('b-button', {
    staticClass: "pull-right",
    attrs: {
      "variant": "danger"
    },
    on: {
      "click": _vm.closemultibillConfirm
    }
  }, [_vm._v(" Close")])], 1)], 1)
},staticRenderFns: []}


//////////////////
// WEBPACK FOOTER
// ./~/vue-loader/lib/template-compiler?{"id":"data-v-39ff9b93","hasScoped":false}!./~/vue-loader/lib/selector.js?type=template&index=0!./src/component/allModuleForm/viewMultiBillingDetails.vue
// module id = 2529
// module chunks = 0